export const clientLifecycleError = (error, fallback) => (
  error?.payload?.userMessage || error?.response?.data?.error?.message ||
  error?.response?.data?.message || error?.payload?.message?.error?.message ||
  ((error?.payload?.status || error?.response?.status) === 403
    ? 'Your account does not have permission to manage clients. Please ask the salon owner.' : fallback)
);
